import * as React from 'react'

function SvgGl(props) {
	return (
		<svg viewBox="0 0 18 12" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M0 0h18v12H0z" />
			<path fill="#d00c33" d="M0 6h18v6H0zm3 0a4 4 0 008 0 4 4 0 00-8 0" />
		</svg>
	)
}

export default SvgGl
